// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"96ba43d9","372":"96ba43d9","903":"96ba43d9"}[chunkId] + ".chunk.css";
};